// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import { NgClass, NgStyle } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { IconComponent } from '@lbca-shared/icon';
import { ErrorOverlayClass } from '../../error-overlay/error-overlay.directive';
import {
  PopupFeedbackDirective,
  PopupInterfaceCommunication,
} from '../../popup-feedback/popup-feedback.directive';

@Component({
  selector: 'lbca-input-text-rounded',
  templateUrl: './input-text-rounded.component.html',
  styleUrl: './input-text-rounded.component.scss',
  imports: [NgStyle, NgClass, IconComponent],
})
export class InputTextRoundedComponent {
  private overlay = inject(Overlay);

  private popupFeedController = new PopupInterfaceCommunication();

  @HostBinding('attr.lbcaPopupFeedback') popupFeedback = new PopupFeedbackDirective(
    this.overlay,
    this.popupFeedController
  );

  @ViewChild('templateCopy') templateCopy!: TemplateRef<any>;

  private errorPopup!: ErrorOverlayClass;

  @ViewChild('inputData', { static: true }) inputData!: ElementRef;

  public hasMask: boolean = false;

  public isTouched: boolean = false;
  public hasError: boolean = false;
  public isRequired: boolean = false;
  public isDisabled: boolean = false;
  public isEditable: boolean = false;
  public isReadOnly: boolean = false;

  public isValidIcon: boolean = false;
  public isLabeled: boolean = false;
  public isTabeled: boolean = false;
  public isChosed: boolean = false;
  public confirm: boolean = true;
  public copy: boolean = true;

  public labelValue: string = '';
  public helperTextValue: string = '';
  public placeholder: string = '';
  public labelValueTemp: string = '';
  public maskIcon: any = null;

  public inputComponetIconStyle: any = null;
  public inputComponetIconSize: 'sm' | 'normal' | 'lg' = 'normal';
  public inputComponetHelperIconStyle: any = null;
  public componentFilling: any = null;
  public dataInput: any = null;

  public valueToReturn: any = '';
  public render: boolean = false;

  public isShowErrorPopup: boolean = true;

  private readInputTimeOutDebounce: any = null;

  private setValueUserEventToMaskCallback: any = null;
  private setValueInputToMaskCallback: any = null;
  private validateCallback: any = null;
  private getMaskErrorCallback: any = null;
  public errorFeed: boolean = false;

  public isLoading = false;

  constructor() {
    const overlay = this.overlay;
    const elementRef = inject(ElementRef);

    this.errorPopup = new ErrorOverlayClass(overlay);
    this.errorPopup.setPosition(
      elementRef,
      [
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ],
      0,
      0,
      'top',
      'end'
    );
  }

  @Input() set chosed(value: boolean) {
    this.isChosed = value;
  }

  @Input() set showErrorPopup(value: boolean) {
    this.isShowErrorPopup = value;
  }
  @Input() set tabeled(value: boolean) {
    this.isTabeled = value;
  }
  @Input() set labeled(value: boolean) {
    this.isLabeled = !value;
  }
  @Input() set editable(value: boolean) {
    this.isEditable = value;
  }
  @Input() set require(status: boolean) {
    this.isRequired = status;
  }
  @Input() set readonly(read: boolean) {
    this.isReadOnly = read;
  }
  @Input() set disabled(disabled: boolean) {
    this.isDisabled = disabled;
  }
  @Input() set helperText(value: string) {
    this.helperTextValue = value;
  }
  @Input() set label(value: string) {
    this.labelValue = value;
    this.labelValueTemp = value;
  }
  @Input() set hasExternalError(value: boolean) {
    this.hasError = value;
  }
  @Input() set copyContent(value: boolean) {
    this.copy = value;
  }
  @Input() set data(value: any) {
    this.dataInput = value;
  }
  @Input() set loadingState(value: any) {
    this.isLoading = value;
  }

  @Input() set componetIconStyle(icon: string) {
    this.inputComponetIconStyle = icon;
  }
  @Input() set componetHelperIconStyle(icon: string) {
    this.inputComponetHelperIconStyle = icon;
  }
  @Input() set componetIconSize(icon: 'sm' | 'normal' | 'lg') {
    this.inputComponetIconSize = icon;
  }

  @Input() set spacing(value: string) {
    this.componentFilling = value;
  }

  @Input('hasErrorMessageFeedback')
  set hasErrorMessageFeed(error) {
    if (error && error.length > 0) {
      this.errorFeed = true;
      this.labelValue = error[0];
    } else {
      this.errorFeed = false;
      this.labelValue = this.labelValueTemp;
      this.errorPopup.setErrors([]);
    }
  }

  @Input('error')
  set err(error) {
    if (error && error.length > 0) {
      this.hasError = true;
      // this.errorPopup.setErrors(error);
    } else {
      if (this.errorFeed) return;
      this.hasError = false;
      // this.errorPopup.setErrors([]);
    }
  }

  @Input()
  set value(value) {
    this.valueToReturn = '';
    this.inputData!.nativeElement.value = '';
    if (value) {
      // await mask initialization
      setTimeout(() => {
        this.valueToReturn = value;
        this.isTouched = true;
        if (!this.hasMask) this.inputData!.nativeElement.value = value;
        else this.inputData!.nativeElement.value = this.setValueInputToMaskCallback(value);
        setTimeout(() => this.checkIsValidate(), 50);
      }, 5);
    }
  }

  @Output('tryActionAgain') tryAgainEmitter = new EventEmitter();

  @Output('changeValue') changeEmmiter = new EventEmitter();

  @Output() focusState = new EventEmitter();
  @Output('confirm') confirmEmitter = new EventEmitter();

  @Output('setError') setErrorEmmiter = new EventEmitter();
  @Output('validStatus') validStatusEmmiter = new EventEmitter();

  public inputKeyUpEvent($event) {
    if (this.isReadOnly) return;
    clearTimeout(this.readInputTimeOutDebounce);

    this.hasError = false;
    this.isValidIcon = false;

    this.readInputTimeOutDebounce = setTimeout(() => {
      if (this.hasMask) {
        const cursorStart = $event.target.selectionStart;
        const { pureValue, formatedValue, formatedCursorPosition } =
          this.setValueUserEventToMaskCallback($event.target.value, cursorStart);

        this.valueToReturn = pureValue;
        $event.target.value = formatedValue;

        if ($event.code.substring(0, 5) === 'Arrow') return;
        if ($event.code.substring(0, 5) === 'Shift') return;
        if ($event.code.substring(0, 7) === 'Control') return;

        $event.target.selectionEnd = formatedCursorPosition;
        $event.target.selectionStart = formatedCursorPosition;
        this.validStatusEmmiter.emit(false);
      } else {
        this.valueToReturn = $event.target.value;
        if (this.valueToReturn) this.validStatusEmmiter.emit(true);
        else this.validStatusEmmiter.emit(false);
      }
      this.changeEmmiter.emit(this.valueToReturn);
    }, 25);
  }

  public focusIn(): void {
    this.focusState.emit(true);
    if (this.isShowErrorPopup) {
      this.errorPopup.setFocus(true);
    }

    if (this.errorFeed) {
      this.tryAgainEmitter.emit(true);
      return;
    }

    this.isTouched = true;
    this.isLabeled = false;
  }

  public focusOut(): void {
    setTimeout(async () => {
      if (!this.inputData!.nativeElement.value) this.isTouched = false;
      this.checkIsValidate();
      this.errorPopup.setFocus(false);
    }, 25);
    this.focusState.emit(false);
  }

  private async checkIsValidate() {
    if (!this.valueToReturn) return;
    if (this.hasMask) {
      const { isValid, insertIcon } = await this.validateCallback(this.valueToReturn);

      if (insertIcon) this.isValidIcon = isValid;

      if (isValid) {
        this.hasError = false;
        // Zera o erro
        this.setErrorEmmiter.emit([]);
        this.validStatusEmmiter.emit(true);
      } else {
        this.hasError = true;
        this.validStatusEmmiter.emit(false);
        this.setErrorEmmiter.emit(this.getMaskErrorCallback());
      }
    }
  }

  confirmAction($event) {
    if (this.valueToReturn) {
      $event.preventDefault();
      this.confirmEmitter.emit(true);
    }
  }

  public copyToClipboard($event): void {
    $event.preventDefault();
    $event.stopPropagation();
    navigator.clipboard.writeText(this.inputData!.nativeElement.value).then(() => {
      this.popupFeedController.show(this.templateCopy);
      setTimeout(() => this.popupFeedController.close(), 4000);
    });
  }
}
